import { render, staticRenderFns } from "./input-sms.vue?vue&type=template&id=7f83965c&"
import script from "./input-sms.vue?vue&type=script&lang=js&"
export * from "./input-sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports